module.exports = __webpack_public_path__ + "img/repair.6050f7c9.svg";